import { EmbedUrlType } from '@/modules/embedurl/constants/EmbedUrlType';
import { Component } from 'vue';
import VideoEmbed from '@/modules/embedurl/components/presentational/VideoEmbed.vue';
import GoogleSlideEmbed from '@/modules/embedurl/components/presentational/GoogleSlideEmbed.vue';
import HtmlEmbed from '@/modules/embedurl/components/presentational/HtmlEmbed.vue';

export class EmbedViewFactory {
  getEmbedComponent(type: EmbedUrlType): Component {
    switch (type) {
      case EmbedUrlType.VIDEO:
        return VideoEmbed;
      case EmbedUrlType.GOOGLE_SLIDE:
        return GoogleSlideEmbed;
      case EmbedUrlType.HTML:
      default:
        return HtmlEmbed;
    }
  }
}

export default new EmbedViewFactory();
